module.exports = __webpack_public_path__ + "static/media/blog3.c917246c.jpg";